export default __webpack_public_path__ + "static/media/download3.5b3da232.svg";